import styled from 'styled-components';

import {
  Drfq,
  getDrfqStatusLabel,
} from '@paradigm/features/src/unified-rfqs/entities/drfq/domain';
import iconWarning from '@paradigm/design-system/src/assets/icon-warning-yellow.svg';
import { StrategyDescription } from '../components/strategy-description/StrategyDescription';

interface Props {
  readonly drfq: Drfq;
}

export default function ToastRfqClosed({ drfq }: Props) {
  return (
    <Container data-testid={`drfq-${drfq.id}-closed-toast`}>
      <img src={iconWarning} width="22px" height="22px" alt="warning" />
      <div>
        <span>RFQ {getDrfqStatusLabel(drfq, false)}</span>
        <StyledStrategyDescription>
          {drfq.description}
        </StyledStrategyDescription>
      </div>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 22px auto;
  align-items: center;
  grid-auto-flow: column;
`;

const StyledStrategyDescription = styled(StrategyDescription)`
  color: white;
  font-size: 14px;
`;
